import React from "react";
const getFillColor = (color: string) => {
  return color === "currentColor" ? `` : `var(--color-${color})`;
};
const SvgExploreIcon = ({ title, theme = null, titleId = "", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
    width="1em"
    height="1em"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g className="explore_svg__nc-icon-wrapper">
      <path
        data-color="color-2"
        d="M32 14c-9.925 0-18 8.075-18 18s8.075 18 18 18 18-8.075 18-18-8.075-18-18-18zm0 34c-8.822 0-16-7.178-16-16s7.178-16 16-16 16 7.178 16 16-7.178 16-16 16z"
      />
      <circle cx={32} cy={32} r={4} />
      <path d="M61.581 22.702a1 1 0 1 0-1.908.6A28.975 28.975 0 0 1 61 32c0 15.991-13.009 29-29 29S3 47.991 3 32 16.009 3 32 3a28.757 28.757 0 0 1 16.259 5.006A6.96 6.96 0 0 0 47 12c0 3.86 3.14 7 7 7s7-3.14 7-7-3.14-7-7-7a6.958 6.958 0 0 0-4.355 1.53A30.748 30.748 0 0 0 32 1C14.907 1 1 14.907 1 32s13.907 31 31 31 31-13.907 31-31c0-3.171-.478-6.3-1.419-9.298z" />
    </g>
  </svg>
);
export interface Props {
  color?: string;
  width?: string;
  height?: string;
  title: string;
  titleId?: string;
  theme?: any;
  fill?: string;
}
const SvgExploreStyle = ({
  color = "currentColor",
  title,
  fill,
  ...props
}: Props) => (
  <SvgExploreIcon
    color={getFillColor(color)}
    className={color === "currentColor" ? "icon-current-color" : ""}
    {...(color !== "currentColor"
      ? { style: { color: getFillColor(color), fill: getFillColor(color) } }
      : null)}
    fill={fill ?? getFillColor(color)}
    title={title}
    {...props}
  />
);
export const ExploreIcon: any = SvgExploreStyle;
export default ExploreIcon;
